export default "__VITE_ASSET__82cbc2ac__"